define(function(require, exports, module) {
    'use strict';

    var config = require('config');
    var _ = require('underscore');
    var url = require('util/totalcasino-theme/url.util');

    var PageManager = function() {
        this.init();
    };

    PageManager.prototype = {
        $pageInListCache: {},

        init: function() {
        },

        getPathname: function(pathname) {
            return this.getCleanUrl(pathname || url.pathname);
        },

        getCleanUrl: function(pathname) {
            pathname = '/' + pathname.replace(/^\/+|\/+$/g, '');
            return url.getCleanUrl(pathname);
        },

        isGameCashierPage: function(path) {
            return this.isPageInList(path, 'gameCashiersPages');
        },

        isPageInList: function(path, listName) {
            path = this.getPathname(path);

            var hash = path + listName;
            var fromCache = this.$pageInListCache[hash];

            if (fromCache === undefined) {
                var pagesList = config.get(listName);

                this.$pageInListCache[hash] = fromCache = _.contains(_.toArray(pagesList), path);
            }

            return fromCache;
        },

        isCashierPage: function(path) {
            return this.isDefaultCashierPage(path) || this.isGameCashierPage(path);
        },

        isRegisterPage: function(path) {
            path = this.getPathname(path);

            // TODO: hardcode, need to use root-page-class and delete page manager.
            var registerPages = Playtech.Variables.registerPages || ['/register-fast', '/register'];

            return registerPages.includes(path);
        },

        isDefaultCashierPage: function(path) {
            return this.isPageInList(path, 'cashiersPages');
        },

        isCashierAddCardPage: function(path) {
            path = this.getPathname(path);

            var addCardPages = [
                config.get('cashiersPages.addcardDeposit'),
                config.get('gameCashiersPages.addcardDeposit')
            ];

            return _.contains(addCardPages, path);
        },

        getCashierDepositPageURL: function() {
            // eslint-disable-next-line no-shadow
            var url;

            if (this.isGameCashierPage()) {
                url = config.get('gameCashiersPages.deposit');
            } else {
                url = config.get('cashiersPages.deposit');
            }

            return url;
        }
    };

    module.exports = new PageManager();
});
